import * as IoC from 'inversify';
import { registerCommand, registerQuery } from '@/app/tracking/api';
import { StateSerializationPluginSymbol } from '@/app/state-serialization/api';
import * as Api from '../api'
import * as Serialization from '../serialization'
import { BadgeSuspendDataStateStore } from './badge-suspend-data-state-store'
import { QueryBadgeStatesQueryHandler } from './query-badge-states-query-handler';
import { EarnBadgesCommandHandler } from './earn-badges-command-handler';

export const badgeCommonTrackingModule = new IoC.ContainerModule((bind) => {
  bind(BadgeSuspendDataStateStore).toSelf().inSingletonScope();
  registerCommand(Api.EarnBadgesCommandName, EarnBadgesCommandHandler, bind);
  registerQuery(Api.QueryBadgeStatesTrackingQueryName, QueryBadgeStatesQueryHandler, bind);
  bind(StateSerializationPluginSymbol).to(Serialization.BadgeStateProtobufSerializer)
})
